import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

const books=[
  {
    id:1,
    img:"https://m.media-amazon.com/images/I/51W-r3VQlAL._SX320_BO1,204,203,200_.jpg",
    author:"Colleen Hoover"
  },
  {
    id:2,
    img:"https://m.media-amazon.com/images/I/41ZHPT8mG8L._SY264_BO1,204,203,200_QL40_FMwebp_.jpg",
    author:"Elena Armas"
  },
  {
    id:3,
    img:"https://m.media-amazon.com/images/I/51vPFsSO-WL._SY264_BO1,204,203,200_QL40_FMwebp_.jpg",
    author:"Ali Hazelwood"
  },
  {
    id:4,
    img:"https://m.media-amazon.com/images/I/41MV32mYXJL._SX323_BO1,204,203,200_.jpg",
    author:"Divya Anand"
  },
  {
    id:5,
    img:"https://m.media-amazon.com/images/I/51ben7xI6ZL._SY264_BO1,204,203,200_QL40_FMwebp_.jpg",
    author:"Datta Durjoy"
  },
  {
    id:6,
    img:"https://m.media-amazon.com/images/I/61R-HtwVuYL._SY264_BO1,204,203,200_QL40_FMwebp_.jpg",
    author:"Durjoy Datta"
  },
  {
    id:7,
    img:"https://m.media-amazon.com/images/I/61XG5TJgxbL._SY264_BO1,204,203,200_QL40_FMwebp_.jpg",
    author:"Durjoy Datta"
  },
  {
    id:8,
    img:"https://m.media-amazon.com/images/I/41nx3WH7tIL._SY264_BO1,204,203,200_QL40_FMwebp_.jpg",
    author:"Durjoy Datta"
  },
  {
    id:9,
    img:"https://m.media-amazon.com/images/I/41lXGsGtrzS._SX460_BO1,204,203,200_.jpg",
    author:"Antoine De Saint-Exupéry"
  },
  {
    id:10,
    img:"https://m.media-amazon.com/images/I/415bo3f7KqL._SY264_BO1,204,203,200_QL40_FMwebp_.jpg",
    author:"Antoine De Saint-exupéry"
  }
];

const Booklist=()=>{
  return(
    <>
    <h1 className='heading'>Library</h1>
    <div className='container'>
      {books.map((book)=>{
        return <Book book={book} key={book.id}/>
      })}
    </div>
    {/* <textarea name="" id="txt" cols="30" rows="10" className="txt" value={text}></textarea> */}
    </>
  );
}
const Book=(props)=>{
  const{img,author}=props.book;
  console.log(props);
  
  return(
  <section className='book-p'>
      <div className="book">
        <img src={props.book.img} alt="" />
        <h2>{author}</h2>
        <button onClick={()=>handleClick(author)} className="btn">Click</button>
      </div>
  </section>
  )
}

let text;
const handleClick=(author)=>{
  console.log(author);
  text="The author of selected book is "+author;
  alert('The author of selected book is '+author);
  return(
    <div>
      <h1>
      The author of selected book is {author}.
     </h1>
    </div>
  );
}
// ReactDOM.createRoot(document.getElementById('txt')).render(<handleClick/>);

ReactDOM.createRoot(document.getElementById('root')).render(<Booklist/>);
